import useColColorSchema from './columns/useColColorSchema';
import useColDeleteSchema from './columns/useColDeleteSchema';
import useColEditSchema from './columns/useColEditSchema';
import useColImageSchema from './columns/useColImageSchema';
import useColImportantSchema from './columns/useColImportantSchema';
import useColNumberSchema from './columns/useColNumberSchema';
import useColPocketCheckboxSchema from './columns/useColPocketCheckboxSchema';
import useColPocketTextSchema from './columns/useColPocketTextSchema';
import useColPocketTitleSchema from './columns/useColPocketTitleSchema';
import useColPocketTypeSchema from './columns/useColPocketTypeSchema';

export default function usePocketSchema({
    columns, ...pocketProps
}) {
    const schemaMap = {
        number: useColNumberSchema,
        important: useColImportantSchema,
        checkbox: useColPocketCheckboxSchema,
        color: useColColorSchema,
        image: useColImageSchema,
        type: useColPocketTypeSchema,
        title: useColPocketTitleSchema,
        text: useColPocketTextSchema,
        edit: useColEditSchema,
        delete: useColDeleteSchema,
    };

    const pocketSchema = columns.map((column) => ({
        // поля, специфичные для колонки
        ...schemaMap[column.type]({
            ...pocketProps,
            accessor: column.accessor || column.type,
            title: column.title,
            titleIcon: column.titleIcon,
            attributes: column.attributes,
            disabledAccessor: column.disabledAccessor,
        }),

        // общие поля, которые затем прокинутся в DataTable
        type: column.type,
    }));

    return pocketSchema;
}
